document.querySelectorAll('.product__media-item img').forEach(img => {
  img.style.cursor = 'zoom-in';
  img.addEventListener('mousemove', function(e) {
    const rect = this.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    this.style.transformOrigin = `${x}% ${y}%`;
    this.style.transform = "scale(2)";
  });
  img.addEventListener('mouseleave', function() {
    this.style.transform = "scale(1)";
  });
});
